import type { Intent } from '@jet/environment/dispatching';

export enum GetStaticCanonicalUrlIntentKind {
    Name = 'GetStaticCanonicalUrlIntent',
}

export interface GetStaticCanonicalUrlIntent
    extends Intent<string | undefined> {
    $kind: GetStaticCanonicalUrlIntentKind.Name;
    intent: Intent<unknown>;
}

export function makeGetStaticCanonicalUrlIntent(
    options: Omit<GetStaticCanonicalUrlIntent, '$kind'>,
): GetStaticCanonicalUrlIntent {
    return {
        ...options,
        $kind: GetStaticCanonicalUrlIntentKind.Name,
    };
}

export function isGetStaticCanonicalUrlIntent(
    intent: Intent<unknown>,
): intent is GetStaticCanonicalUrlIntent {
    return intent.$kind === GetStaticCanonicalUrlIntentKind.Name;
}
